function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
var _React_PureComponent;
class Form extends (_React_PureComponent = React.PureComponent) {
    submitForm(evt) {
        evt.preventDefault();
        this.props.onSubmit();
    }
    resetForm() {
        this.props.onReset();
    }
    render() {
        return /*#__PURE__*/ _jsx("form", {
            action: "#",
            className: cn(this.props.className),
            onSubmit: (evt)=>this.submitForm(evt),
            onReset: ()=>this.resetForm(),
            children: this.props.children
        });
    }
}
_define_property(Form, "propTypes", {
    children: PropTypes.node,
    onSubmit: PropTypes.func,
    onReset: PropTypes.func,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ])
});
_define_property(Form, "defaultProps", {
    onSubmit: ()=>{},
    onReset: ()=>{}
});
export default Form;
